import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material';

import { Link } from 'react-router-dom';
import React from 'react';
import { Routes } from 'src/utils/enums';
import { content } from 'src/common/lang/en-US';

const DiscountBanner: React.FC = () => {
  const { title, subTitle } = content.landingPage.banner;
  const xsScreen = useMediaQuery('(max-width:700px)');
  const smScreen = useMediaQuery('(max-width:900px)');
  return (
    <Box sx={{ backgroundImage: "inherit", bgcolor: "transparent" }}>
      <Box
        px={(xsScreen || smScreen) ? 2 : 10}
        display="grid"
        gap={10}
        gridTemplateColumns={{
          xs: '1fr',
          sm: '2.5fr 1.5fr',
          md: '2.5fr 1.5fr',
        }}
      >
        <Stack direction="column" gap={2}>
          <Typography color='primary.light' variant='subtitle1'>{title}</Typography>
          <Typography lineHeight={1.7} color='primary.light' variant='h4_Thin'>{subTitle}</Typography>
        </Stack>
        <Stack justifyContent="center" direction="column" gap={2}>
          <Link to={Routes.CONTACT_PAGE}>
          <Button
            sx={{
              color: "primary.light",
              border: "2px solid #FFFFFF",
              padding: "18px 30px",
              borderRadius: "30px",
            }}
            fullWidth
          >
            Contact Us
          </Button>
          </Link>
        </Stack>
      </Box>
    </Box>
  )
};

export default DiscountBanner;
